var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71689 7.72434C7.97886 7.81167 8.26202 7.67009 8.34934 7.40811C8.43667 7.14614 8.29509 6.86298 8.03311 6.77566L7.71689 7.72434ZM6 6.625H5.5C5.5 6.84022 5.63771 7.03128 5.84189 7.09934L6 6.625ZM6.5 4.01159C6.5 3.73545 6.27614 3.51159 6 3.51159C5.72386 3.51159 5.5 3.73545 5.5 4.01159H6.5ZM7.875 7.25L8.03311 6.77566L6.15811 6.15066L6 6.625L5.84189 7.09934L7.71689 7.72434L7.875 7.25ZM6 6.625H6.5V4.01159H6H5.5V6.625H6ZM11 6H10.5C10.5 8.48528 8.48528 10.5 6 10.5V11V11.5C9.03757 11.5 11.5 9.03757 11.5 6H11ZM6 11V10.5C3.51472 10.5 1.5 8.48528 1.5 6H1H0.5C0.5 9.03757 2.96243 11.5 6 11.5V11ZM1 6H1.5C1.5 3.51472 3.51472 1.5 6 1.5V1V0.5C2.96243 0.5 0.5 2.96243 0.5 6H1ZM6 1V1.5C8.48528 1.5 10.5 3.51472 10.5 6H11H11.5C11.5 2.96243 9.03757 0.5 6 0.5V1Z",
    fill: "#FFA500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.ee63df073e862a3e4f6fb71590c00e40.svg";
export { ForwardRef as ReactComponent };